module.exports = __webpack_public_path__ + "img/avatar-zelf-vrouw.b5b67256.jpeg";